module.exports = __webpack_public_path__ + "static/media/Other-Rooftop.9876630b.jpg";